import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';

export const reportIssueAddon: ExtensionDefinition = AddonBlueprint.make({
  name: 'report-issue',
  params: {
    name: 'ReportIssue',
    location: TechDocsAddonLocations.Header,
    component: ReportIssue,
  },
});
